import renderImage from '../../source/importImg'

function ClassPredictionsPanel({ classPredictions, onClose }) {
    return (
        <div
        ><div 
            style={{position: 'absolute', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 10, backgroundColor: 'rgba(0, 0, 0, 0.1)'}}
            > </div>
        <div
            style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    maxWidth: '90%',
                    width: '400px',
                    background: '#fff',
                    padding: '20px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
                    position: 'relative',
                }}
            >
                <img
                    style={{
                        position: 'absolute',
                        width: '2.5rem',
                        right: '-10px',
                        top: '-10px',
                        cursor: 'pointer',
                    }}
                    src={renderImage('clos')}
                    onClick={onClose}
                />

                <h3
                    style={{
                        marginTop: '0',
                        fontSize: '18px',
                        textAlign: 'center',
                    }}
                >
                    Class Predictions
                </h3>
                {Object.keys(classPredictions).length >
                0 ? (
                    Object.entries(classPredictions).map(
                        ([classId, predData]) => {
                            
                            const confidence =
                                predData.confidence || 0
                            const percentage = Math.round(
                                confidence * 100
                            )
                            // Determine bar color based on confidence
                            let barColor = '#ccc' // gray
                            if (confidence > 0.85) {
                                barColor = '#4CAF50' // green - high confidence
                            } else if (confidence > 0.5) {
                                barColor = '#ff9800' // orange - medium confidence
                            } else if (confidence > 0.2) {
                                barColor = '#f44336' // red - low confidence
                            }

                            return (
                                <div
                                    key={classId}
                                    style={{
                                        borderBottom:
                                            '1px solid #eee',
                                        paddingBottom:
                                            '8px',
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent:
                                                'space-between',
                                            marginBottom:
                                                '5px',
                                            fontSize:
                                                '14px',
                                        }}
                                    >
                                        <span>
                                            {
                                                predData.className
                                            }
                                        </span>
                                        <span
                                            style={{
                                                fontWeight:
                                                    'bold',
                                            }}
                                        >
                                            {percentage}%
                                        </span>
                                    </div>
                                    <div
                                        style={{
                                            width: '100%',
                                            height: '24px',
                                            backgroundColor:
                                                '#f0f0f0',
                                            borderRadius:
                                                '4px',
                                            overflow:
                                                'hidden',
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: `${percentage}%`,
                                                height: '100%',
                                                backgroundColor:
                                                    barColor,
                                                transition:
                                                    'width 0.3s ease',
                                            }}
                                        />
                                    </div>
                                </div>
                            )
                        }
                    )
                ) : (
                    <p
                        style={{
                            textAlign: 'center',
                            color: '#999',
                        }}
                    >
                        No predictions yet. Start recording
                        to see predictions.
                    </p>
                )}
            </div>
        </div>
        </div>
    )
}

export default ClassPredictionsPanel
